/*
 * Module for the ScheduleModel editor template.  
 * 
 * This module publishes an event named "momentChanged" when the user toggles between
 * Now and Later for when to execute a job.  Subscribers listen to events by calling 
 * the Subscribe method.
 */
rs.module("jobs/schedule-editor",

    [
        "common/select-helper",
        "common/visibility"
    ],

    function (selectHelper, visibility) {

        var subscribers = [];

        var recurrenceBasisSelectHelper;
        var recurrenceBasisOptions;

        // initialize the module
        function initialize(jsSelectors, config) {
            var editorForm = $.js(jsSelectors.schedule);
            var detail = $(editorForm).js(jsSelectors.detail);

            // select list for Now or Later
            var momentSelect = $(editorForm).js(jsSelectors.moment, { required: false });

            // select list for recurrence basis: Minute, Hour, Day, Week, or Month
            var recurrenceBasisSelect = $(editorForm).js(jsSelectors.recurrenceBasisSelect);
            recurrenceBasisSelectHelper = selectHelper.getHelper(recurrenceBasisSelect);
            recurrenceBasisOptions = config.recurrenceBasisOptions;

            // select list for Repeat "every" or Repeat "on chosen months"
            var recurrenceRepeatSelect = $(editorForm).js(jsSelectors.recurrenceRepeatSelect);
            var recurrenceRepeatSelectHelper = selectHelper.getHelper(recurrenceRepeatSelect);

            // select list for Days of the week when basis is weekly, or the montly type selection when
            // the basis is monthly
            var recurrenceDetailSelect = $(editorForm).js(jsSelectors.recurrenceDetailSelect);
            var recurrenceDetailSelectHelper = selectHelper.getHelper(recurrenceDetailSelect);

            // repeatEvery input
            var repeatInput = $(editorForm).js(jsSelectors.repeatInput);

            // second level of monthly recurrence definition.  Holds numeric days of the month or week ranking
            var recurrenceSecondaryDetailSelect = $(editorForm).js(jsSelectors.recurrenceSecondaryDetailSelect);
            var recurrenceSecondaryDetailSelectHelper = selectHelper.getHelper(recurrenceSecondaryDetailSelect);

            // dynamic labels
            var repeatEveryLabel = $(editorForm).js(jsSelectors.repeatEveryLabel);
            var recurrenceDetailLabel = $(editorForm).js(jsSelectors.recurrenceDetailLabel);
            var recurrenceSecondaryDetailLabel = $(editorForm).js(jsSelectors.recurrenceSecondaryDetailLabel);

            // whole sections which get shown or hidden
            var monthSections = $(editorForm).js(jsSelectors.monthSections, { multiple: true });
            var monthRecurrenceSections = $(editorForm).js(jsSelectors.monthRecurrenceSection, { multiple: true });
            var repeatSections = $(editorForm).js(jsSelectors.repeatSection, { multiple: true });
            var recurrenceSections = $(editorForm).js(jsSelectors.recurrenceSections, { multiple: true });
            var monthRecurrenceTertiarySections = $(editorForm).js(jsSelectors.monthRecurrenceTertiarySections, { multiple: true });

            var scheduleEnd = $(editorForm).js(jsSelectors.scheduleEnd);

            // set the initial state for recurrence detail multiselect
            _setRecurrenceDetailMultiselectState();

            // hook up change handlers
            momentSelect.change(_momentChanged);
            scheduleEnd.change(_scheduleEndChanged);
            recurrenceBasisSelect.change(_recurrenceBasisChanged);
            recurrenceRepeatSelect.change(_recurrenceRepeatChanged);
            recurrenceDetailSelect.change(_recurrenceDetailChanged);

            // the Moment was changed
            function _momentChanged() {
                var selectedValue = momentSelect.val();

                _notifyEvent("momentChanged", selectedValue);

                // show detail only if Later is chosen
                _show(detail, selectedValue == config.moment.later);
            }

            // Set an input to be enabled or disabled
            function _disableInput(input, disable) {
                $(input).prop("disabled", disable);
            }

            // Recurring By changed
            function _recurrenceBasisChanged() {
                var selectedValue = recurrenceBasisSelect.val();

                if (selectedValue == config.recurrenceBasis.once.value) {
                    visibility.hide($(editorForm).js(jsSelectors.notForOneTimeSection, { multiple: true }));

                    // disable the repeatEvery input because if the user enters a value incompatible with int, model binding fails
                    // even when the value isn't used in OneTime.  Disabling prevents sending the value.
                    _disableInput(repeatInput, true);
                }
                else {
                    // re-enable the Repeat Every
                    _disableInput(repeatInput, false);

                    visibility.show($(editorForm).js(jsSelectors.notForOneTimeSection, { multiple: true }));

                    _getChildProperties(config.recurrenceBasis).forEach(basis => {
                        if (basis.value == selectedValue) {
                            // fill Repeat select with repeat options
                            recurrenceRepeatSelectHelper.replaceOptions(basis.repititionOptions);

                            // update the helper text, ex.  "repeat every X (days|weeks|months)"
                            repeatEveryLabel.html(basis.repeatEveryLabel);

                            // if there are recurrence options, update and show the section
                            if (basis.recurrenceValues) {
                                visibility.show(recurrenceSections);

                                // update the recurrence label and options
                                recurrenceDetailLabel.html(basis.recurrenceDetailLabel);
                                recurrenceDetailSelectHelper.replaceOptions(basis.recurrenceValues.items);

                                // recurrence options can be multi-select or not
                                recurrenceDetailSelectHelper.setMultiSelect(basis.recurrenceValues.multiple);
                            }
                            else {
                                visibility.hide(recurrenceSections);
                            }

                            // toggle visibility of month sections
                            _show(monthSections, basis.value == config.recurrenceBasis.month.value);
                        }
                    });

                    // cascade changes to recurrence repeat
                    _recurrenceRepeatChanged();
                    _recurrenceDetailChanged();
                }
            }

            // Recurrence Detail select changed
            function _recurrenceDetailChanged() {
                var monthlyBasis = config.recurrenceBasis.month;
                if (recurrenceBasisSelect.val() == monthlyBasis.value) {

                    var selectedValue = recurrenceDetailSelect.val();

                    var toCheck = [monthlyBasis.monthRecurrenceType.numericDay, monthlyBasis.monthRecurrenceType.selectedDays];
                    toCheck.forEach(option => {
                        if (option.value == selectedValue) {
                            // set the sub items and label
                            recurrenceSecondaryDetailSelectHelper.replaceOptions(option.recurrenceSecondaryValues.items);
                            recurrenceSecondaryDetailLabel.html(option.recurrenceSecondaryValues.label);

                            // determine to show or hide tertiary selection
                            _show(monthRecurrenceTertiarySections, option.tertiarySectionVisible);
                        }
                    });
                }
            }

            // Razor automatically forces mutliselect on select lists when the backing property
            // is IEnumerable.  So we need to disable multiselect when montly recurrence basis
            // is chosen.
            function _setRecurrenceDetailMultiselectState() {
                var selectedRecurrenceBasis = recurrenceBasisSelect.val();

                if (selectedRecurrenceBasis == config.recurrenceBasis.month.value) {
                    recurrenceDetailSelectHelper.setMultiSelect(config.recurrenceBasis.month.multiple);
                }
            }

            // show or hide elements
            function _show(el, visible) {
                if (visible) {
                    visibility.show(el);
                }
                else {
                    visibility.hide(el);
                }
            }

            // The Repeat select list has changed
            function _recurrenceRepeatChanged() {
                var selectedValue = recurrenceRepeatSelect.val();

                var selectedRecurrenceBasis = recurrenceBasisSelect.val();

                // show or hide the month selection list
                var showMonthSelection = selectedValue == config.recurrenceRepeat.chosen && selectedRecurrenceBasis == config.recurrenceBasis.month.value

                // show and hide month/repeat sections
                monthRecurrenceSections.each(function () { _show($(this), showMonthSelection) });
                repeatSections.each(function () { _show($(this), !showMonthSelection) });
            }

            // The End selection has changed
            function _scheduleEndChanged() {
                var selected = Number(scheduleEnd.val());

                var toShow = [];
                var toHide = [];

                // read config to see which End Value sections need to be shown or hidden
                _getChildProperties(config.scheduleEnd).forEach(endDefinition => {
                    if (endDefinition.value === selected) {
                        if (endDefinition.selector) {
                            editorForm.js(endDefinition.selector, { multiple: true }).each(function () { toShow.push($(this)); });
                        }
                    }
                    else {
                        if (endDefinition.selector) {
                            editorForm.js(endDefinition.selector, { multiple: true }).each(function () { toHide.push($(this)); });
                        }
                    }
                });

                toShow.forEach(item => _show(item, true));
                toHide.forEach(item => _show(item, false));
            }

            // Gets the properties of a javascript object
            function _getChildProperties(obj) {
                var children = []
                for (var property in obj) {
                    if (obj.hasOwnProperty(property)) {
                        children.push(obj[property]);
                    }
                }

                return children;
            }

            // Notify listeners of an event
            function _notifyEvent(eventName, args) {
                subscribers.forEach(function (subscriber) {
                    if (subscriber[eventName] != undefined) {
                        subscriber[eventName](args);
                    }
                });
            }
        }

        // subscribe to published events
        function subscribe(handlers) {
            subscribers.push(handlers);
        }

        // update the recurrence basis options according to the isRecurringAllowed flag
        function setRecurrenceBasis(isRecurringAllowed) {
            recurrenceBasisSelectHelper.replaceOptions(isRecurringAllowed ? recurrenceBasisOptions.all : recurrenceBasisOptions.once);
        }

        // Exported public API
        var exports = {
            initialize: initialize,
            subscribe: subscribe,
            setRecurrenceBasis: setRecurrenceBasis
        };

        return exports;
    }
);